<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="businessDetailGroupInfo.groups" border style="width: 100%">
        <el-table-column prop="groupId" label="编号" align="center"></el-table-column>
        <el-table-column label="商品图片" align="center">
          <template slot-scope="scope">
            <el-image 
              style="width: 50px; height: 50px; border-radius: 10px;"
              :src="scope.row.coverPhoto" 
              :preview-src-list="[scope.row.coverPhoto]"
              fit="cover">
              <div slot="error" class="image-slot">
                <img src="/img/noPhoto.jpg" style="width: 50px; height: 50px; border-radius: 10px;">
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="prodName" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="userCount" label="拼团人数" align="center"></el-table-column>
        <el-table-column label="拼团金额" align="center">
          <template slot-scope="scope">￥{{scope.row.groupPrice}}</template>
        </el-table-column>
        <el-table-column label="单买金额" align="center">
          <template slot-scope="scope">￥{{scope.row.price}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{scope.row.state == '1001'?'启用':'停用'}}
          </template>
        </el-table-column>
        <el-table-column label="有效期" align="center">
          <template slot-scope="scope">
            {{scope.row.startTime}}~{{scope.row.endTime}}
          </template>
        </el-table-column>
        <el-table-column label="是否返佣" align="center">
          <template slot-scope="scope">
            {{scope.row.rebateFlag == 'Y'?'是':'否'}}
          </template>
        </el-table-column>
        <el-table-column label="团长返佣" align="center">
          <template slot-scope="scope">
            {{scope.row.rebate}}%
          </template>
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="8"></el-col>
        <el-col :span="16" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    businessDetailGroupInfo: {
      type: Object,
      default: () => ({
        groups: [],
        link: ''
      })
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.$emit('page-change', val, this.pageSize)
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 15px;
}
.text-right {
  text-align: right;
}
</style>